var _path, _circle;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgAllReplies = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 2.8125L6.46544 6.74187C6.92826 7.06006 7.15967 7.21915 7.41138 7.28077C7.63373 7.33521 7.86627 7.33521 8.08861 7.28077C8.34033 7.21915 8.57174 7.06006 9.03456 6.74187L14.75 2.8125M4.11 11.75H11.39C12.5661 11.75 13.1542 11.75 13.6034 11.5252C13.9985 11.3275 14.3198 11.0119 14.5211 10.6239C14.75 10.1827 14.75 9.60511 14.75 8.45V4.05C14.75 2.89489 14.75 2.31734 14.5211 1.87614C14.3198 1.48806 13.9985 1.17254 13.6034 0.974799C13.1542 0.75 12.5661 0.75 11.39 0.75H4.11C2.93389 0.75 2.34583 0.75 1.89662 0.974799C1.50148 1.17254 1.18022 1.48806 0.978886 1.87614C0.75 2.31734 0.75 2.89489 0.75 4.05V8.45C0.75 9.60511 0.75 10.1827 0.978886 10.6239C1.18022 11.0119 1.50148 11.3275 1.89662 11.5252C2.34583 11.75 2.93389 11.75 4.11 11.75Z",
    stroke: "#535353",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.75,
    cy: 10.75,
    r: 3.5,
    fill: "#535353",
    stroke: "white",
    strokeWidth: 2
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAllReplies, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/all-replies.75a78d36.svg";
export { ForwardRef as ReactComponent };